const redirect = function jump(context, path) {
    if (context.$route.path != path) context.$router.push(path);
}

export default redirect